import { Component, OnInit, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from '../../services/order/order.service';
import { OrderDetail } from '../../models/order/order-detail.model';
import { Brand } from '../../models/brand/brand-model';
import { Customer, VendorDropDown } from '../../models/customer/customer-model';
import { Product } from '../../models/products/product.model';
import { ProductService } from '../../services/product/product.service';
import { CustomerService } from '../../services/customer/customer.service';
import { BrandService } from '../../services/brand/brand.service';
import { EnumDropDown } from '../../models/shared/enum-dropdown'
import { UtilitiesService } from '../../services/shared/utilities.service';
import { CreatePurchaseOrder } from '../../models/PurchaseOrder/create-purchase-order.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { GenericService } from '../../services/generic.service';
import { debounce } from 'rxjs/operators';
@Component({
  selector: 'app-purchase-order-list',
  templateUrl: './purchase-order-list.component.html',
  styleUrls: ['./purchase-order-list.component.scss']
})
/** purchase-order-list component*/
export class PurchaseOrderListComponent {
  /** purchase-order-list ctor */
  public orderDetails: OrderDetail[];
  public filteredItems: OrderDetail[];
  public ProductType: string;
  public ProductList: Product[];
  public productidDistinct: number[];
  public customerList: VendorDropDown[];
  public VendorLiveSearch: VendorDropDown[];
  public showSuggestionsLive: boolean = false;
  public purchasOrderStatuses: EnumDropDown[];
  public brandtList: Brand[];
  public vendorID: string;
  public arrRowsPerPage: number[];
  public rowsOnPage: number=10;
  public searchKeyword: string;
  public orderDetailForPo: number[] = [];
  public isCreateAllowed: boolean = false;
  public createPurchaseOrder: CreatePurchaseOrder;

  public pagenumber: number = 0;
  public rowsPerPage: number = 10;
  public totalRecord: number = 0;
  public showBoundaryLinks: boolean;
  public isLoaded: boolean = false;
  people2Loading: boolean = false;
  searchVendorName: string = "";
  @ViewChild('btnCPO') btnCPO: ElementRef;
  constructor(private readonly orderService: OrderService,
    private _avRoute: ActivatedRoute, private _router: Router, private readonly ProductService: ProductService,
    private readonly BrandService: BrandService,
    private readonly CustomerService: CustomerService,
    private readonly utilitiesService: UtilitiesService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private genericService: GenericService) {
    this.pagenumber = 0;
    this.rowsOnPage = 10;
    this.rowsPerPage = 10;
    this.searchKeyword = "";
    this.isLoaded = false;
    this.showBoundaryLinks = true;
    this.toastr.setRootViewContainerRef(vcr);
    this.checkPermission();
    this.ProductList = [];
    this.purchasOrderStatuses = [];
    this.customerList = [];
    this.brandtList = [];
   // this.getApprovedOrders();
    this.vendorID = "";
 
    this.createPurchaseOrder = new CreatePurchaseOrder();
    this.createPurchaseOrder.orderDetails = [];
   // this.GetRowsPerPageList();
   // this.getBrands();
    this.getVendors();
    this.getProcessOrderStatuses();
    this.OnFilterChange();
    

  }

  LiveSearchVendor(searchText: string) {
    this.vendorID = "";
    
    var length = 0;
    try {
      length = searchText.length;
    } catch (e) {
      return;
    }
    if (length > 0) {
      this.VendorLiveSearch = [];
      this.showSuggestionsLive = true;
      let regexp = new RegExp(searchText.toLowerCase());
      this.VendorLiveSearch = this.customerList.filter(x => x.shopeName.toLowerCase().match(regexp))
    }
    else {
      this.vendorID = "";
      this.showSuggestionsLive = false;
      this.VendorLiveSearch = this.customerList;
      this.searchVendorName = "";
      this.OnFilterChange();
    }
  }

  SelectVendor(product: VendorDropDown) {
    this.searchVendorName = product.shopeName;
    this.vendorID = product.customerID.toString();
    this.showSuggestionsLive = false;
    this.OnFilterChange();
  }
  RemoveSelected() {
    if (this.searchVendorName != "") {
      this.searchVendorName = "";
      this.vendorID = "";
      this.OnFilterChange();
    }
    

  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("purchaseorderlist").subscribe(
      data => {
        if (data != null) {
          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          if (create.length > 0)
            this.isCreateAllowed = true;
          if (list.length > 0) {

          }
          else {
            this._router.navigate(["/"]);
          }
        }
        else {
          this._router.navigate(["/"]);
        }
      }
    )
  }
  //GetApprovedOrders
  getApprovedOrders() {
    this.orderService.GetApprovedOrderDetail().subscribe(
      data => {
        this.orderDetails = data;
        this.filteredItems = data;
        this.getProdducts(this.ProductType);
      });
  }
  ifProductExist(productID: number) {
    return (this.ProductList.find(i => i.productID == productID) == undefined);
  }
  ifVendorExist(vendorID: number) {
    return (this.customerList.find(i => i.customerID == vendorID) == undefined);
  }
  ifBrandExist(brandID: number) {
    return (this.brandtList.find(i => i.brandID == brandID) == undefined);
  }
  ifPurchaseOrderStatuses(id: number) {
    return (this.purchasOrderStatuses.find(i => i.value == id) == undefined);
  }

  getProdducts(type: string) {
    this.ProductType = type;
    this.ProductList = [];
    this.productidDistinct = [];
    for (var i = 0; i < this.orderDetails.length; i++) {
      if (this.productidDistinct.filter(d => d == this.orderDetails[i].productID).length == 0) {
        this.productidDistinct.push(this.orderDetails[i].productID);
      }
    }
    for (var i = 0; i < this.productidDistinct.length; i++) {
      this.ProductService.GetProductById(this.productidDistinct[i]).subscribe(
        data => {
          this.ProductList.push(data);
        });
    }
  }
  hide() {
    this.showSuggestionsLive = false;
  }
  getVendors() {
    if (this.customerList.length == 0) {
      this.CustomerService.getVendorsDropDown().subscribe(
        data => {
          this.customerList = data;
          this.VendorLiveSearch = this.customerList;
        }
      )
    }
  }
  selectionChanged(event: VendorDropDown) {
    try {
      this.vendorID = event.customerID.toString();
      this.OnFilterChange();
    } catch (e) {

    }
    if (event === undefined) {
      this.vendorID = "";
      this.OnFilterChange();
    }
    

  }
  getBrands() {
    this.BrandService.getBrand().subscribe(
      data => {
        this.brandtList = data;
      }
    )
  }
  getProcessOrderStatuses() {
    this.orderService.GetPurchaseOrderStatuses().subscribe(
      data => {
        this.purchasOrderStatuses = data;
      }
    )
  }


  OnFilterChange() {
    this.pagenumber = 0;
    this.OnFilterChangegrid();
  }

  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.rowsPerPage = $event.itemsPerPage;

    this.OnFilterChangegrid();
  }
  OnFilterChangegrid() {
    if (this.rowsPerPage == undefined) this.rowsPerPage = 10;
    if (this.pagenumber == undefined) this.pagenumber = 0;
    this.orderService.GetPurchasedOrdersGrid(this.pagenumber, this.rowsOnPage, this.searchKeyword, this.vendorID).subscribe(
      data => {
        this.isLoaded = true;
        this.orderDetails = data;
        if (this.orderDetails != null && this.orderDetails.length > 0)
          this.totalRecord = this.orderDetails[0].totalRecords;
        else
          this.totalRecord = 0;

      }
    )
  }
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  PlaceOrder() {
    if (confirm("Do you want to create Purchase orders for following order details")) {
      if (this.orderDetailForPo.length > 0) {
        this.genericService.toggleButtonAnimation(this.btnCPO)
        this.createPurchaseOrder.orderDetails = this.orderDetailForPo;
        this.orderService.PlacePurchaseOrder(this.createPurchaseOrder).subscribe(ob => {
          this.filteredItems = [];
          this.genericService.toggleButtonAnimation(this.btnCPO)
         // this.getApprovedOrders();
          this.OnFilterChange();
          this.toastr.success("Purchase order has been placed.", "Success");
          this.orderDetailForPo = [];
          //this._router.navigate(["/purchase-order-list"]);
        });
      }
      else {
        this.toastr.info("No product selected to create purchase order.","Info")
      }
    }
    //else {
    //  this.toastr.error("Can not place purchase order.", "Error")
    //}
    //this._router.navigate(["purchase-orders"]);

  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.OnFilterChange();
    }
  }
  checkListChange(orderDetailID: number) {
    // if already present : exclude
    // else Add
    if (this.orderDetailForPo.filter(i => i === orderDetailID).length == 0) {
      this.orderDetailForPo.push(orderDetailID);
    }
    else {
      const index: number = this.orderDetailForPo.indexOf(orderDetailID);
      if (index !== -1) {
        this.orderDetailForPo.splice(index, 1);
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/order-components/purchase-order-list/purchase-order-list.component.ts